
export const LOCAL_CART = 'cart'